import * as React from "react";
const SvgLogoPaiement = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 36 22"
    {...props}
  >
    <g clipPath="url(#logo_paiement_svg__a)">
      <rect
        width={34.755}
        height={21.649}
        x={0.176}
        y={0.176}
        fill="#FF5F39"
        stroke="#DEDCDC"
        strokeWidth={0.351}
        rx={1.697}
      />
      <path
        fill="#fff"
        d="M30.771 9.005v.77a2.6 2.6 0 0 0-2.012-.91c-1.602 0-2.843 1.299-2.843 2.901s1.241 2.9 2.843 2.9c.889 0 1.628-.4 2.11-1.03v.892h1.532V9.005zm-1.612 4.278c-.891 0-1.613-.68-1.613-1.517s.722-1.517 1.613-1.517c.89 0 1.612.68 1.612 1.517 0 .838-.721 1.517-1.612 1.517m-17.062-5.81h1.631v7.054h-1.63zm3.505 3.924c0-1.52 1.03-2.531 2.455-2.531.885 0 1.584.356 2.005.963.422-.607 1.12-.963 2.006-.963 1.425 0 2.454 1.012 2.454 2.53v3.13h-1.63v-3.289c0-.592-.433-.979-1.007-.979s-1.007.387-1.007.979v3.29h-1.63v-3.29c0-.592-.434-.979-1.008-.979s-1.007.387-1.007.979v3.29h-1.63zM9.146 9.062c-.387-1.31-1.202-1.729-1.98-1.729-.777 0-1.593.42-1.979 1.73l-1.676 5.465h1.652c.269-.912 1.098-1.422 2.003-1.422.906 0 1.734.509 2.004 1.422h1.652zm-1.98 2.77c-.525 0-1.002.18-1.353.473l.947-3.18c.09-.304.224-.4.408-.4s.316.096.407.4l.947 3.18a2.12 2.12 0 0 0-1.356-.473"
      />
    </g>
    <defs>
      <clipPath id="logo_paiement_svg__a">
        <path fill="#fff" d="M0 0h35.106v22H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoPaiement;
